import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, Building2 } from "lucide-react";
import {
  partnerApi, storePartnerSession, isPartnerLoggedIn, formatPartnerError,
} from "./partnerApi";
import { BRAND } from "@/lib/brandingConfig";
import "./PartnerPortal.css";

export default function PartnerLogin() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(params.get("expired") ? "Your session expired. Please sign in again." : "");

  useEffect(() => {
    if (isPartnerLoggedIn()) nav("/partner/portal", { replace: true });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await partnerApi.post("/partner/auth/login", { email, password });
      storePartnerSession(data.access_token, data);
      nav("/partner/portal", { replace: true });
    } catch (e) {
      setErr(formatPartnerError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="hw-pp__auth-shell" data-testid="partner-login-page">
      <div className="hw-pp__auth-card">
        <img
          src={BRAND.logo}
          alt={BRAND.logoAlt}
          className="hw-pp__brand-logo"
          data-testid="partner-login-brand-logo"
          style={{ height: 44, width: "auto", marginBottom: "0.75rem" }}
        />
        <div className="hw-pp__eyebrow">
          <Building2 className="w-3.5 h-3.5"
                       style={{ display: "inline", verticalAlign: "text-bottom", marginRight: "0.3rem" }} />
          HarborWell Connect · Partner Portal
        </div>
        <h1 className="hw-pp__auth-title">Welcome back</h1>
        <p className="hw-pp__auth-sub">
          Sign in to manage your organization&apos;s integration with HarborWell Connect.
        </p>

        <form onSubmit={submit}>
          <label className="hw-pp__field">
            <span className="hw-pp__field-label">Work email</span>
            <input className="hw-pp__input" type="email" required autoFocus
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="partner-login-email" />
          </label>
          <label className="hw-pp__field">
            <span className="hw-pp__field-label">Password</span>
            <input className="hw-pp__input" type="password" required minLength={12}
                    value={password} onChange={(e) => setPassword(e.target.value)}
                    data-testid="partner-login-password" />
          </label>

          {err && <div className="hw-pp__error" data-testid="partner-login-error">{err}</div>}

          <button type="submit" className="hw-pp__btn hw-pp__btn--primary hw-pp__btn--full"
                    disabled={busy || !email || password.length < 1}
                    data-testid="partner-login-submit">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Sign in
          </button>
        </form>

        <div className="hw-pp__helper">
          Invite link expired? Ask your partner owner to re-invite you.
        </div>
      </div>
    </div>
  );
}
